export const AI_SUPPORT_ALLOWED_LINK_PREFIXES : Array<string> = [
  '#/',
  'https://workshopsoftware.com/knowledge-base/'
];

export const AI_SUPPORT_IDLE_CHECK_MS   = 60000;
export const AI_SUPPORT_IDLE_CLOSE_MS   = 3600000;
export const AI_SUPPORT_IDLE_WARNING_MS = 1800000;
export const AI_SUPPORT_MAX_QUESTION    = 500;
export const AI_SUPPORT_OPEN_FLAG       = 'ai_support';
export const AI_SUPPORT_OPEN_VALUE      = 'open';
export const AI_SUPPORT_TIMEOUT_MS      = 60000;
